import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=50f48bd2&scoped=true&"
import script from "./Instructor?vue&type=script&lang=js&"
export * from "./Instructor?vue&type=script&lang=js&"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=50f48bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f48bd2",
  null
  
)

export default component.exports